import { getCookieValue } from "../../cookieHelper";
import { GET_SKILL_OUTCOME_SUMMARY, GET_SKILL_OUTCOME_SUMMARY_SUCCESS, GET_SKILL_OUTCOME_SUMMARY_FAILURE, TRIGGER_TOAST } from "../constants";
import { SkillOutcomeSummary } from "./../../queries";

const getSkillOutcome = (userId: number) => {
  return async (dispatch: any) => {
    dispatch({ type: GET_SKILL_OUTCOME_SUMMARY });
    if (!!sessionStorage.getItem("isDemoUser")) {
      const dummyData = require("../../data/MockData/skillOutcomeSummary.json");
      dispatch({ type: GET_SKILL_OUTCOME_SUMMARY_SUCCESS, payload: { ...dummyData } });
    }
    else {
      const request = {
        method: "POST",
        headers: {
          "content-type": "application/json",
          'Accept': 'application/json',
          "Authorization": `Bearer ${getCookieValue(`${process.env.REACT_APP_ENV}IdToken`)}`
        },
        body: JSON.stringify({ query: SkillOutcomeSummary(userId) })
      };
      const data = fetch(`${process.env["REACT_APP_INSIGHTGRAPHQLENDPOINT"]}`, request);
      data.then(skillJson => skillJson.json()).then((skillOutcomeData: any) => {
        if (skillOutcomeData) {
          dispatch({ type: GET_SKILL_OUTCOME_SUMMARY_SUCCESS, payload: { ...skillOutcomeData } });
        } else {
          // handleError(err);
          dispatch({ type: GET_SKILL_OUTCOME_SUMMARY_SUCCESS });
          dispatch({
            type: TRIGGER_TOAST,
            payload: {
              shouldShow: true,
              severity: 'error',
              transMessage: "message_errorDefault"
            },
          });
        }
      })
        .catch((err: any) => {
          // handleError(err);
          dispatch({ type: GET_SKILL_OUTCOME_SUMMARY_FAILURE });
          dispatch({
            type: TRIGGER_TOAST,
            payload: {
              shouldShow: true,
              severity: 'error',
              transMessage: "message_errorDefault"
            },
          });
        });
    }
  };
};

export default {
  getSkillOutcome,
};
